module.exports = __webpack_public_path__ + "cbac2d4acb5710d69d74479b338b02b0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/images/facebook-logo.svg
// module id = 466
// module chunks = 0